import { Model } from "@vuex-orm/core";
import { required, maxLength, decimal } from "vuelidate/lib/validators";
import Material from "./Material";
import Coating from "./Coating";
import State from "./State";
import Batch from "./Batch";
import { WorkOrderAttachment } from "./Attachment";
import Project from "./Project";
import ToolProcess from "./ToolProcess";

export default class WorkOrder extends Model {
  static entity = 'workorders';

  static $fetchActive() {
    return this.api().get('WorkOrders/?archived=false')
  }
  static $fetchAll() {
    return this.api().get('WorkOrders/')
  }
  static $get (id) {
    return this.api().get(`WorkOrders/${id}/`)
  }
  static $put (id, data){
    return this.api().put(`WorkOrders/${id}/`, data)
  }
  static $patch (id, data){
    return this.api().patch(`WorkOrders/${id}/`, data)
  }
  static $post (data){
    return this.api().post(`WorkOrders/`, data)
  }

  static fields() {
    return {
      id: this.attr(null),
      isWorkOrder: this.boolean(true),
      forgeID: this.string("placeholder"),
      icon: this.string("fas fa-cubes"),
      name: this.string(""),
      created: this.string(""),
      lastmodified: this.string(""),
      richtext: this.string(""),
      description: this.string(""),
      recipe: this.string(""),
      qcinstructions: this.string(""),
      coatedquantity: this.string("100"),
      witnessquantity: this.string("100"),
      batchquantity: this.string("100"),
      units: this.string("g"),
      picoshield: this.boolean(false),
      archived: this.boolean(false),
      active: this.boolean(false),
      project: this.belongsTo(Project, "project_id"),
      project_id: this.attr(null),
      coating: this.belongsTo(Coating, "coating_id"),
      coating_id: this.attr(null),
      material: this.belongsTo(Material, "material_id"),
      material_id: this.attr(null),
      toolprocess: this.hasMany(ToolProcess, "workorder_id"),
      state: this.belongsTo(State, "state_id"),
      state_id: this.attr(null),
      attachments: this.hasMany(WorkOrderAttachment, "workorder_id"),
      children: this.hasMany(Batch, "workorder_id")
    };
  }
  toCreatePayload() {
    return {
      forgeID: this.forgeID,
      name: this.name,
      coatedquantity: this.coatedquantity,
      witnessquantity: this.witnessquantity,
      batchquantity: this.batchquantity,
      picoshield: this.picoshield,
      archived: this.archived,
      project: this.project_id,
      coating: this.coating_id,
      material: this.material_id,
      units: this.units
    };
  }
  toUpdatePayload() {
    return {
      id: this.$id,
      ...this.toCreatePayload()
    };
  }
  static get validations() {
    return {
      formdata: {
        name: { required, maxLength: maxLength(124) },
        coatedquantity: { required, maxLength: maxLength(13), decimal },
        witnessquantity: { required, maxLength: maxLength(13), decimal },
        batchquantity: { required, maxLength: maxLength(13), decimal },
        units: { required },
        coating_id: { required },
        material_id: { required },
      }
    };
  }
}

